
import type { AsyncDataOptions } from '#app';
import type { FetchOptions } from 'ofetch';
import FetchFactory from '../factory';


class PaymentModule extends FetchFactory<IPaymentAccount> {
  private RESOURCE = '/payment';

  async accountsMe(
    query: string,
    fetchOptions?: FetchOptions<'json', string>,
    asyncDataOptions?: AsyncDataOptions<FetchResponse<IPaymentAccount[]>>
  ) {
    return useAsyncData(
      "payment/accountsMe",
      () => {
        return this.call(
          `${this.RESOURCE}/accounts/me?${query}`,
          fetchOptions
        )
      },
      asyncDataOptions
    )
  };

  async accounts(
    query: string,
    fetchOptions?: FetchOptions<'json', string>,
    asyncDataOptions?: AsyncDataOptions<FetchResponse<IPaymentAccount[]>>
  ) {
    return useAsyncData(
      "payment/accounts",
      () => {
        return this.call(
          `${this.RESOURCE}/accounts?${query}`,
          fetchOptions
        )
      },
      asyncDataOptions
    )
  };

}

export default PaymentModule;

